import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

function HeaderBarBack({ title }) {
	const navigate = useNavigate();

	return (
		<div
			style={{
				backgroundColor: 'white',
				padding: '10px',
				display: 'flex',
				alignItems: 'center',
				boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
				borderRadius: '5px',
				position: 'fixed',
				top: '0',
				left: '0',
				width: '100%',
				zIndex: '1000',
			}}
		>
			<button
				onClick={() => navigate(-1)}
				style={{
					background: 'none',
					border: 'none',
					cursor: 'pointer',
					marginLeft: '10px',
					fontSize: '20px',
					color: '#333',
				}}
			>
				<FaArrowLeft />
			</button>
			<p
				style={{
					fontSize: '20px',
					fontWeight: 'bold',
					margin: '0 auto',
					color: '#333',
				}}
			>
				{title}
			</p>
		</div>
	);
}

export default HeaderBarBack;
